import React from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import classNames from 'classnames';

// Turing components
import TuringFooterV2 from '../../legacy_components/UI_V2_Components/home/HomeV2/TuringFooterV2';
import '../../assets/css/Content.css';
import { PageConstant } from '../../constants';

const { Content } = Layout;

function LayoutContainer (props) {
  const { children, opened, path, history } = props;
  const routeClassMaps = {
    [PageConstant.DASHBOARD_DEV]: 'remove-padding', 
    [PageConstant.FAST_TRACK_PAGE]: 'remove-padding', 
    [PageConstant.JOB_PAGE]: 'remove-padding',
    [PageConstant.NEW_PROFILE_PAGE]: 'remove-padding',
    [PageConstant.MCQ_LIST]: 'remove-padding',
    [PageConstant.ACCOUNT]: 'remove-padding',
  };

  return (
    <Layout className="contentColumn">
      <div className={classNames(['stretcher', 'scrollable', opened ? '' : 'leftDrawerCollapsed'])}>
        <Content className={routeClassMaps[path] || ''}>
          {children}
        </Content>
        <TuringFooterV2 history={history} />
      </div>
    </Layout>
  );
}

const mapStateToProps = (state) => {
  return Object.assign({}, {...state.drawer});
};

export default connect(mapStateToProps, null)(LayoutContainer);